import { track } from "./tracker";

export const IMPRESSION_FLUSH_DELAY_MS = 2_000;
export const IMPRESSION_BATCH_LIMIT = 50;
export const IMPRESSION_VISIBLE_RATIO = 0.5;

interface Impression {
  productId: string;
  position: number;
}

export interface ImpressionBatcher {
  seen(impression: Impression): void;
  flush(): void;
}

export function createImpressionBatcher(list: string): ImpressionBatcher {
  const counted = new Set<string>();
  let pending: Impression[] = [];
  let timer: ReturnType<typeof setTimeout> | null = null;

  function flush(): void {
    if (timer !== null) clearTimeout(timer);
    timer = null;
    if (pending.length === 0) return;
    const batch = pending;
    pending = [];
    track("listing.cards_seen", {
      list,
      product_ids: batch.map((impression) => impression.productId),
      positions: batch.map((impression) => impression.position),
      count: batch.length,
    });
  }

  return {
    seen(impression) {
      if (counted.has(impression.productId)) return;
      counted.add(impression.productId);
      pending.push(impression);
      if (pending.length >= IMPRESSION_BATCH_LIMIT) flush();
      else timer ??= setTimeout(flush, IMPRESSION_FLUSH_DELAY_MS);
    },
    flush,
  };
}
